import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { PrimaryHeader, SecondaryHeader, NavBackButton, BackIcon } from '../styles/global'
import { submitPathogen } from '../utils/api.utils'
import TextField from '@material-ui/core/TextField'
import Fab from '@material-ui/core/Fab';

import { PathogenForm } from '../components/PathogenForm'
import { SequenceForm } from '../components/SequenceForm'

interface Props {
  pathogen: any
  shouldDisplay: any
  fetchPathogens: any
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <div>{children}</div>
      )}
    </div>
  );
}

export function PathogenEditor({ pathogen, shouldDisplay, fetchPathogens }: Props) {
  const [currentPathogen, setPathogen] = useState(pathogen);
  const [isValid, setIsValid] = useState<boolean>(currentPathogen.name !== '');
  const [tabValue, setTab] = useState<number>(0);

  useEffect(() => {
    setPathogen((targetPathogen: any) => ({
      ...targetPathogen,
      name: targetPathogen.name || ''
    }))
  }, []);

  const handleTabChange = (event: any, newValue: number) => {
    setTab(newValue);
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  function savePathogen() {
    submitPathogen(currentPathogen)
      .then((response: any) => {
        fetchPathogens()
        shouldDisplay(false)
        return response
      }).catch((err: any) => console.error(err))
  }

  return (
    <EditorWrapper>
      <EditorHeader>
        <NavBackButton startIcon={<BackIcon />} onClick={() => shouldDisplay(false)}>
          Back to Pathogens
        </NavBackButton>
        <PrimaryHeader style={{ margin: 0 }}>
          {currentPathogen.id ? 'Edit Pathogen' : 'New Pathogen'}
        </PrimaryHeader>
      </EditorHeader>

      <ThemedTabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="pathogen settings categories"
        TabIndicatorProps={{ style: { backgroundColor: '#3f51b5', height: '3px' } }}
      >
        <Tab label="Properties" {...a11yProps(0)} />
        <Tab label="Genetic Sequence" {...a11yProps(1)} />
      </ThemedTabs>

      <TabPanel value={tabValue} index={0}>
        <SectionWrapper>
          <SecondaryHeader>General Information</SecondaryHeader>
          <FormCard>
            <FieldGroup>
              <Label>Pathogen Name *</Label>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="e.g. H5N1 Avian Influenza"
                value={currentPathogen.name || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setPathogen((current: any) => ({ ...current, name: value }));
                  setIsValid(value !== '');
                }}
              />
            </FieldGroup>
          </FormCard>
        </SectionWrapper>

        <SectionWrapper style={{ marginBottom: tabValue === 0 ? '100px' : '40px' }}>
          <SecondaryHeader>Advanced Biological Parameters</SecondaryHeader>
          <FormCard>
            <PathogenForm
              pathogen={currentPathogen}
              setPathogen={setPathogen}
            />
          </FormCard>
        </SectionWrapper>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <SectionWrapper style={{ marginBottom: '100px' }}>
          <SecondaryHeader>Pathogen Identity Matrix</SecondaryHeader>
          <FormCard>
            <SequenceForm id={currentPathogen.id} />
          </FormCard>
        </SectionWrapper>
      </TabPanel>

      {tabValue === 0 && (
        <FabWrapper
          variant="extended"
          color="primary"
          disabled={!isValid}
          onClick={() => savePathogen()}
        >
          SAVE PATHOGEN
        </FabWrapper>
      )}
    </EditorWrapper>
  );
}

const EditorWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding-bottom: 50px;
`;

const EditorHeader = styled.div`
  margin-bottom: 32px;
`;



const SectionWrapper = styled.div`
  margin-bottom: 40px;
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`;

const FieldGroup = styled.div`
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const ThemedTabs = styled((props: any) => <Tabs {...props} />)`
  margin-bottom: 40px;
  border-bottom: 1px solid #e2e8f0;
  .MuiTab-root {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    color: #718096;
    min-width: 160px;
    transition: all 0.2s;
    &.Mui-selected {
      color: #3f51b5;
    }
    &:hover {
      color: #4a5568;
      background: #f7fafc;
    }
  }
`;

const FabWrapper = styled(Fab)`
  && {
    position: fixed;
    right: 40px;
    bottom: 40px;
    background-color: #3f51b5;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0 32px;
    box-shadow: 0 10px 15px -3px rgba(63, 81, 181, 0.4);
    &:hover {
      background-color: #303f9f;
    }
  }
`;